<mat-form-field #formFieldContainer floatLabel="always" class="avl-trace-map-wrapper">
    <mat-label
      #labelContainer  (click)="toggleTooltip(tooltip)"
      class="{{componentDefinition?.mandatory ? 'mandatory' : ''}}">
      {{componentDefinition?.label}}
    </mat-label>
    <div class="labelToolTipContainer"
         #tooltip="matTooltip"
         matTooltip="{{componentDefinition.label}}"
         [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
    </div>
    <input matInput hidden />
    <div style="width: 100%; height: 500px;  overflow: hidden;">
        <div #targetMap [id]="fieldName+'_map'" class="map" style="height: 100%;">

        </div>
         <div id="popup-adress" style="
                display:none;
                text-align: center;
                position: absolute;
                padding: 2px;
                background-color: #ffffff;
                z-index: 999;
                top: 50%;
                left: 50%;
                margin-left: -80px;
                border: 2px solid;
                max-width: 60%;
                border-radius: 4px;
                background-color: white;
                "></div>
    </div>

    <div #containerChart id="chart" style="width: 100%;" [ngClass]="disabled ? 'disable-element' : ''"></div>

    <!-- <ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display> -->
</mat-form-field>
